import { useEffect } from 'react'
import PropTypes from 'prop-types'
import { compose } from 'recompose'
import { connect } from 'react-redux'
import * as memberActions from 'member-actions'

const propTypes = {
  clearShoppingCart: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired,
}

function MemberApplicationReset({ clearShoppingCart, children }) {
  useEffect(() => {
    clearShoppingCart()
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return children
}

MemberApplicationReset.propTypes = propTypes

function mapStateToProps() {
  return {}
}

const mapDispatchToProps = {
  clearShoppingCart: memberActions.clearShoppingCart,
}

export default compose(connect(mapStateToProps, mapDispatchToProps))(
  MemberApplicationReset
)
